import React, { useState } from "react";
import { Container, Form, Button, Alert } from "react-bootstrap";
import { supabase } from "../../config/Supabase";
import ReactGA from "react-ga4";
import SEO from "../utils/SEO";

const AppWaitList = () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState({ fullName: "", email: "" });
  const [success, setSuccess] = useState("");

  const validateForm = () => {
    let isValid = true;
    setError({ fullName: "", email: "" }); // Reset errors

    if (!fullName.trim()) {
      setError((prev) => ({
        ...prev,
        fullName: "Please enter your full name.",
      }));
      isValid = false;
    }

    if (!email.trim()) {
      setError((prev) => ({
        ...prev,
        email: "Please enter your email address.",
      }));
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      setError((prev) => ({
        ...prev,
        email: "Please enter a valid email address.",
      }));
      isValid = false;
    }

    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return; // Stop submission if validation fails
    setSuccess("");

    try {
      // Store in Supabase (public anon INSERT — see app_waitlist RLS in
      // supabase/migrations/20260727000001_public_lead_forms.sql). 23505 =
      // unique violation -> this email already joined the waitlist.
      const { error: insertError } = await supabase
        .from("app_waitlist")
        .insert({
          full_name: fullName.trim(),
          email: email.trim().toLowerCase(),
          source: window.location.pathname,
        });

      const alreadyJoined = insertError && insertError.code === "23505";
      if (insertError && !alreadyJoined) throw insertError;

      ReactGA.event({
        category: "Waitlist Form",
        action: "Submit Success",
        label: "Join Waitlist",
      });

      setFullName("");
      setEmail("");
      setError({ fullName: "", email: "" });
      setSuccess(
        alreadyJoined
          ? "You're already on the waitlist — we'll be in touch!"
          : "You're on the list! We'll email you when the app is ready."
      );
    } catch (submitError) {
      console.error("Error adding document: ", submitError);

      ReactGA.event({
        category: "Waitlist Form",
        action: "Submit Failed",
        label: "Supabase Error",
      });
      setError((prev) => ({
        ...prev,
        email: "Something went wrong. Please try again.",
      }));
    }
  };

  return (
    <Container
      className="mt-5"
      style={{ maxWidth: "700px", minHeight: "500px" }}
    >
      <SEO
        title="Download the Sarv App - Personalized Herbal Health on Mobile"
        description="Join the Sarv app waitlist. Get personalized herbal medicine recommendations on iOS and Android. Be first to access our holistic health platform."
        canonicalPath="/app-waitlist"
        keywords="Sarv app download, herbal medicine app iOS, holistic health app Android, personalized wellness app, app waitlist"
      />
      <h2
        style={{
          marginBottom: "50px",
          marginTop: "150px",
          fontFamily: "Canela",
          color: "#0a0a39",
        }}
      >
        Our application is under development; submit your email to be notified
        when the app is ready in the app store.
      </h2>

      <Form onSubmit={handleSubmit}>
        <Form.Group
          className="mb-3"
          controlId="formFullName"
          style={{ width: "600px" }}
        >
          <Form.Control
            type="text"
            placeholder="Enter your full name"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            isInvalid={!!error.fullName}
          />
          <Form.Control.Feedback type="invalid">
            {error.fullName}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group
          className="mb-3"
          controlId="formBasicEmail"
          style={{ width: "600px" }}
        >
          <Form.Control
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            isInvalid={!!error.email}
          />
          <Form.Control.Feedback type="invalid">
            {error.email}
          </Form.Control.Feedback>
        </Form.Group>
        <div
          className="d-flex justify-content-center"
          style={{ paddingBottom: "100px", paddingTop: "30px" }}
        >
          <Button variant="primary" type="submit" className="business-button">
            Join the Waitlist
          </Button>
        </div>
        {success && <Alert variant="success">{success}</Alert>}
      </Form>
    </Container>
  );
};

export default AppWaitList;
